module.exports = {"id":"dp4_3l3q5","text":"Supporting Wellbeing","instructions":"The right to disconnect supports wellbeing by helping individuals manage boundaries around digital technology use.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l3q5-a1","text":"True","score":3.7},{"id":"dp4_3l3q5-a2","text":"Not sure","score":1.3},{"id":"dp4_3l3q5-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l3q5.json
// module id = 1254
// module chunks = 41